var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Type } from "class-transformer";
import { ArrayNotEmpty, IsArray, IsEnum, IsNotEmpty, IsOptional, IsString, ValidateNested } from "class-validator";
import { DocumentRetrievalAuthType, DocumentRetrievalTaskSource } from "./document.retrieval.dtos";
export class TefcaEndpointOverrideMatchCriteria {
}
__decorate([
    IsArray(),
    ArrayNotEmpty(),
    IsString({ each: true }),
    IsNotEmpty({ each: true }),
    IsOptional()
], TefcaEndpointOverrideMatchCriteria.prototype, "hcids", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    IsOptional()
], TefcaEndpointOverrideMatchCriteria.prototype, "organizationName", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    IsOptional()
], TefcaEndpointOverrideMatchCriteria.prototype, "fhirUrl", void 0);
export class TefcaEndpointOverrideTargetMetadata {
}
__decorate([
    IsString(),
    IsNotEmpty()
], TefcaEndpointOverrideTargetMetadata.prototype, "brandId", void 0);
__decorate([
    IsString(),
    IsNotEmpty()
], TefcaEndpointOverrideTargetMetadata.prototype, "portalId", void 0);
__decorate([
    IsString(),
    IsNotEmpty()
], TefcaEndpointOverrideTargetMetadata.prototype, "endpointId", void 0);
export class TefcaEndpointOverrideTarget {
}
__decorate([
    IsEnum(DocumentRetrievalTaskSource)
], TefcaEndpointOverrideTarget.prototype, "source", void 0);
__decorate([
    IsEnum(DocumentRetrievalAuthType)
], TefcaEndpointOverrideTarget.prototype, "authType", void 0);
__decorate([
    IsString(),
    IsOptional()
], TefcaEndpointOverrideTarget.prototype, "organizationName", void 0);
__decorate([
    ValidateNested(),
    Type(() => TefcaEndpointOverrideTargetMetadata)
], TefcaEndpointOverrideTarget.prototype, "metadata", void 0);
export class TefcaEndpointOverrideRule {
}
__decorate([
    ValidateNested(),
    Type(() => TefcaEndpointOverrideMatchCriteria)
], TefcaEndpointOverrideRule.prototype, "matchCriteria", void 0);
__decorate([
    ValidateNested(),
    Type(() => TefcaEndpointOverrideTarget)
], TefcaEndpointOverrideRule.prototype, "overrideTarget", void 0);
export class TefcaEndpointOverrideConfig {
}
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => TefcaEndpointOverrideRule)
], TefcaEndpointOverrideConfig.prototype, "overrideRules", void 0);
export class FastenEndpointRef {
}
__decorate([
    IsString(),
    IsNotEmpty()
], FastenEndpointRef.prototype, "brandId", void 0);
__decorate([
    IsString(),
    IsNotEmpty()
], FastenEndpointRef.prototype, "portalId", void 0);
__decorate([
    IsString(),
    IsNotEmpty()
], FastenEndpointRef.prototype, "endpointId", void 0);
__decorate([
    IsString(),
    IsOptional()
], FastenEndpointRef.prototype, "organizationName", void 0);
export class RoFastenEpicLookupConfig {
}
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => FastenEndpointRef),
    IsOptional()
], RoFastenEpicLookupConfig.prototype, "forceFastenEndpoints", void 0);
export function isForceFastenEndpoint(config, brandId, portalId, endpointId) {
    if (!(config === null || config === void 0 ? void 0 : config.forceFastenEndpoints)) {
        return false;
    }
    return config.forceFastenEndpoints.some((entry) => entry.brandId === brandId && entry.portalId === portalId && entry.endpointId === endpointId);
}
